import { useCallback } from 'react';
export const useCalcLabelOffset = (minValue, maxRange, trackEle) => {
  return useCallback((value, labelEle) => {
    if (labelEle && trackEle) {
      const {
        width: labelWidth
      } = labelEle.getBoundingClientRect();
      const {
        width: trackWidth
      } = trackEle.getBoundingClientRect();

      /*
      |<------------------ track width ------------------>|
      |<----- distToBeg ------->|<----- distToEnd ------->|
      |                     [ LABEL ]                     | // threshold label with notch
      [===============( )=======v=========================] // slider
                                 `-- position e.g 50%
      */

      const position = (value - minValue) / maxRange;
      const distToBeg = trackWidth * position;
      const distToEnd = trackWidth * (1 - position);

      // notch label is centered to current position
      const halfLabelWidth = labelWidth / 2;
      if (distToEnd < halfLabelWidth) {
        return distToEnd - halfLabelWidth;
      }
      if (distToBeg < halfLabelWidth) {
        return halfLabelWidth - distToBeg;
      }
    }
    return 0;
  }, [maxRange, minValue, trackEle]);
};